import { Link } from 'react-router-dom';
import { publicRegistry } from '@/i18n/dictionaries/publicRegistry';
import { useTranslation } from '@/i18n/useTranslation';

/**
 * The registry's invitation to join it (§6.3).
 *
 * Registering is self-service: the cabinet entry behind this link is open to any account, because
 * CONSILIER_AGRICOL is granted by validation rather than held beforehand. Said here because the
 * people it concerns are reading the register of advisers, not browsing their own cabinet for a
 * screen they have no reason to expect.
 *
 * A signed-out visitor following it is sent to sign in and comes back: redirectToLogin stashes
 * the path and restoreReturnTo puts it back on the way in, which it does for any /app/ target.
 * Nothing here has to arrange that.
 */
export function AdvisorsRegisterCta() {
  const { t } = useTranslation(publicRegistry);
  return (
    <p className="advisors-cta">
      {t('advisorsCtaLead')}{' '}
      <Link className="btn btn--ghost" to="/app/consilier">
        {t('advisorsCtaLink')}
      </Link>
    </p>
  );
}
